import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import Logo from "@/components/feature/Logo";

interface LegalPageLayoutProps {
  kicker: string;
  title: string;
  meta: string;
  children: ReactNode;
}

export default function LegalPageLayout({ kicker, title, meta, children }: LegalPageLayoutProps) {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <header className="sticky top-0 z-50 border-b border-background-200/70 bg-background-50/95 backdrop-blur-md">
        <div className="relative mx-auto flex h-16 w-full items-center justify-between px-4 md:h-20 md:px-6">
          <Link
            to="/"
            className="flex items-center gap-2.5 font-heading text-lg font-black tracking-wide text-foreground-950 whitespace-nowrap md:text-2xl"
          >
            <Logo className="h-7 md:h-9" />
            株式会社ナンバ
          </Link>
          <Link
            to="/"
            className="flex items-center gap-1.5 rounded-md px-3 py-2 font-label text-sm font-bold text-foreground-800 transition-colors hover:bg-background-100 md:px-4 whitespace-nowrap"
          >
            <i className="ri-arrow-left-line" />
            トップへ戻る
          </Link>
        </div>
      </header>

      <main>
        <section className="bg-background-100 py-14 md:py-20">
          <div className="mx-auto max-w-3xl px-4 text-center md:px-6">
            <p className="font-label text-sm font-bold tracking-[0.2em] text-primary-500">
              {kicker}
            </p>
            <h1 className="mt-4 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-5xl">
              {title}
            </h1>
            <p className="mt-5 font-body text-xs text-foreground-500 md:text-sm">{meta}</p>
          </div>
        </section>

        {children}
      </main>

      <footer className="border-t border-background-200 bg-background-100">
        <div className="mx-auto flex max-w-6xl flex-col items-center justify-between gap-3 px-4 py-8 md:flex-row md:px-6">
          <p className="font-body text-xs text-foreground-500">
            © 2026 NAMBA Inc. All rights reserved.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-5">
            <Link
              to="/"
              className="font-body text-xs text-foreground-500 transition-colors hover:text-foreground-900"
            >
              ホーム
            </Link>
            <Link
              to="/company"
              className="font-body text-xs text-foreground-500 transition-colors hover:text-foreground-900"
            >
              会社概要
            </Link>
            <Link
              to="/privacy-policy"
              className="font-body text-xs text-foreground-500 transition-colors hover:text-foreground-900"
            >
              プライバシーポリシー
            </Link>
            <Link
              to="/terms"
              className="font-body text-xs text-foreground-500 transition-colors hover:text-foreground-900"
            >
              利用規約
            </Link>
            <Link
              to="/legal-notice"
              className="font-body text-xs text-foreground-500 transition-colors hover:text-foreground-900"
            >
              特定商取引法に基づく表記
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}